import { FunctionComponent, ComponentType } from "react";
import { AppsInfoPage } from "../components/AppsInfo";
import { Arquitecture } from "../components/Arquitecture";
import { LoackerWebsites } from "../components/LoackerWebsites";
import { AuthAzurePage } from "../components/AuthAzure";
import { CatalogPage } from "../components/CatalogPage";
import { CentralGatewayPage } from "../components/CentralGateway";
import { AtgolorsdataapiPage } from "../components/AtgolorsdataapiPage";
import { ExternalGatewayPage } from "../components/ExternalGateway";
import { GamesPage } from "../components/Games";
import { HandelsappPage } from "../components/Handelsapp";
import { MonitorPage } from "../components/monitor/MonitorPage";
import { WebsitesAzurePage } from "../components/WebsitesAzure";
import { UserRole } from "../models/types/graphql-global-types";
import { DigidoPage } from "../components/Digido/DigidoPage";
import ButtonsGamePage from "../components/garbageButtons/ButtonsGamePage";
import { SimpleCatalogPage } from "../components/SimpleCatalogPage";
import { DunjaNotes } from "../components/DunjaNotes";
import { AndreasNotes } from "../components/AndreasNotes";


const PORTAL_PATH = "portal";

export interface IPath {
  id: string;
  route?: string;
  component?: FunctionComponent<any> | ComponentType | undefined;
  roles?: UserRole[];
}

interface IPathObject {
  [key: string]: IPath;
}

export const PATH: IPathObject = {
  CATALOG: {
    id: "catalog",
    route: `catalog`,
    component: CatalogPage,
    roles: [UserRole.ADMIN]
  },
  DIGIDO: {
    id: "digido",
    route: `digido`,
    component: DigidoPage,
    roles: [UserRole.ADMIN, UserRole.DIGIDO]
  },
  MONITOR: {
    id: "monitor",
    route: `monitor`,
    component: MonitorPage,
    roles: [UserRole.ADMIN]
  },
  ARCHITECTURE: {
    id: "architecture",
    route: `architecture`,
    component: Arquitecture,
    roles: [UserRole.ADMIN]
  },
  WEBSITES: {
    id: "websites",
    route: `websites`,
    component: LoackerWebsites,
    roles: [UserRole.ADMIN]
  },
  INFO: {
    id: "info",
    route: `info`,
    component: AppsInfoPage,
    roles: [UserRole.ADMIN]
  },
  CENTRALGATEWAY: {
    id: "central",
    route: `central`,
    component: CentralGatewayPage,
    roles: [UserRole.ADMIN]
  },
  EXTERNALGATEWAY: {
    id: "external",
    route: `external`,
    component: ExternalGatewayPage,
    roles: [UserRole.ADMIN]
  },
  ATGOLORSDATAAPI: {
    id: "atgolorsdataapi",
    route: `atgolorsdataapi`,
    component: AtgolorsdataapiPage,
    roles: [UserRole.ADMIN]
  }, HANDELSAPP: {
    id: "handelsapp",
    route: `handelsapp`,
    component: HandelsappPage,
    roles: [UserRole.ADMIN]
  },
  AZURE: {
    id: "azure",
    route: `azure`,
    component: WebsitesAzurePage,
    roles: [UserRole.ADMIN]
  },
  AUTH: {
    id: "auth",
    route: `auth`,
    component: AuthAzurePage,
    roles: [UserRole.ADMIN]
  },
  CHAT: {
    id: "chat",
    route: `chat`,
    component: ButtonsGamePage,
    roles: [UserRole.ADMIN]
  },
  SIMPLE_CATALOG: {
    id: "simple_catalog",
    route: `catalog-simple`,
    component: SimpleCatalogPage,
    roles: [UserRole.ADMIN, UserRole.GUEST, UserRole.UNDEFINED, UserRole.READ_ONLY]
  },
  DUNJA_NOTES: {
    id: "dunja-notes",
    route: `urlaub-backup/dunja`,
    component: DunjaNotes,
    roles: [UserRole.ADMIN]
  },
  ANDREAS_NOTES: {
    id: "andreas-notes",
    route: `urlaub-backup/andreas`,
    component: AndreasNotes,
    roles: [UserRole.ADMIN]
  }
};
